import { type FC, type ReactNode } from 'react';
import { Blue100, ButtonIcon } from '@traceair/tds';
import { ChevronLeftIcon } from '@traceair/webapp-icons';
import { sharedInvoicingCss } from '../styles/shared';

type InvoicePageHeaderProps = {
  title: string;
  onBack: () => void;
  badge: ReactNode;
};

export const InvoicePageHeader: FC<InvoicePageHeaderProps> = ({ title, onBack, badge }) => (
  <div className={sharedInvoicingCss.pageHeader}>
    <ButtonIcon icon={<ChevronLeftIcon color={Blue100} />} size="xs" style="secondary" onClick={onBack} />
    <h1 className={sharedInvoicingCss.pageTitle}>{title}</h1>
    {badge}
  </div>
);
